module.exports = __webpack_public_path__ + "static/crm-88f04d5e1ba3bb2c87a870db1c3aeb8e.jpeg";